<template lang="pug">
div
  slot(v-bind:model="model" v-bind:result="usdtEstimateString" v-bind:dirty="model.rateDirty")
    input.form-control(:value="usdtEstimateString" :state="usdtEstimateInputState" :readonly="readonly")
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";

import {WebFormModel} from "capitalist-shared/src/core/model";
import debounce from "debounce"
import axios from "axios";
import {MoneyFormatFilter} from "@/models/filters/money";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import {CurrencyCode} from "@/models/core/currency";

class EstimateQiwiUsdModel extends WebFormModel {
  rateUpdateStatus = new RemoteRequestState()
  rateDirty = false
  rateCurrent = null
  ratePingDebounced = debounce(this.ratePing, 500)

  values = {
    amount: ''
  }

  validateNumber(amount: string) {
    let value: string = String(amount).trim()
    value = value.replaceAll(/[\s]/g, '')
      .replaceAll(/,/g, '.')

    if (value.match(/[^,.\-\d]/)) {
      return false
    }

    if (Number(value) <= 0) {
      return false
    }

    return true
  }

  rateTouch(amount, currency = CurrencyCode.RUR) {
    this.values.amount = amount
    this.rateCurrent = null
    this.errors.clear('estimate')
    if (!this.validateNumber(amount)) {
      this.rateDirty = false
      return
    }
    this.rateDirty = true
    this.errors.clear('estimate')
    return this.ratePingDebounced(amount, currency, true)
  }

  ratePing(amount, currency = CurrencyCode.RUR, $am = true) {
    if (!this.validateNumber(amount)) {
      this.rateDirty = false
      return
    }
    this.rateUpdateStatus.loadStart()
    // this.errors.clear()
    const callName = $am ? 'checkRateAm' : 'checkRate';
    return axios.post('/webapi/merchants/cardtransfer/' + callName, {
      m: {
        currency,
        amount
      }
    }).then(result => {
      if (amount !== this.values.amount) return;
      this.rateDirty = false
      this.rateUpdateStatus.loadEnd()
      this.rateCurrent = result.data
      return result.data
    }).catch(err => {
      if (amount !== this.values.amount) return
      this.rateDirty = false
      this.errors.set('estimate', 'estimate_error')
      // this.checkAxiosError(err)
      this.rateUpdateStatus.loadError()
      throw err
    })
  }
}

@Component({
  name: "EstimateQiwiUsdAmount",
  filters: {
    money: MoneyFormatFilter
  }
})
export default class EstimateQiwiUsdAmount extends Vue {
  @Prop({default: ''})
  amount: string

  @Prop({default: true})
  visible: boolean

  @Prop({default: true})
  readonly: boolean

  model = new EstimateQiwiUsdModel()

  get usdtEstimateString() {
    if (!this.model.rateDirty && !this.model.rateCurrent) {
      return ''
    }

    if (!this.model.rateDirty && this.model.rateUpdateStatus.isError) {
      return this.$i18n.t('hints.calculating_error')
    }
    if (this.model.rateDirty || !this.model.rateCurrent) {
      return this.$i18n.t('hints.calculating')
    }
    return MoneyFormatFilter((this.model.rateCurrent as any).result.amount, CurrencyCode.USD)
  }

  @Watch('amount')
  onAmountUpdateWatched(newVal) {
    this.touchEstimateUpdate()
  }

  mounted() {
    this.onAmountUpdate()
  }

  onAmountUpdate() {
    this.touchEstimateUpdate()
  }

  touchEstimateUpdate() {
      this.model.rateTouch(this.amount)
      // this.model.errors.clear()
      // this.model.rateCurrent = null
  }

  get isValidNumberAmount() {
    return this.model.validateNumber(this.amount)
  }

  get usdtEstimateInputState() {
    if (!this.model.errors.has('estimate')) {
      return null;
    }

    if (this.model.rateDirty || !this.visible) {
      return null;
    }

    if (!this.model.rateDirty && this.model.rateUpdateStatus.isError) {
      return false;
    }

    if (!this.model.rateDirty && this.model.rateUpdateStatus.isError) {
      return false;
    }

    if (!this.model.rateDirty && this.model.rateCurrent) {
      return true;
    }

    return null;
  }
}
</script>

<style scoped lang="less">

</style>

<i18n>
{
  "en": {
    "estimate_error": "Failed to get rate.",
    "hints": {
      "email": "E-mail for cash receipt.",
      "pan": "Visa, Mastercard or MIR card number.",
      "amount": "Amount limit from {min} to {max} {cur}.",
      "address": "USDT Trc20 address.",
      "calculating": "Evaluating...",
      "calculating_error": "Failed to get rate."
    },
    "labels": {
      "pan": "Card number",
      "amount": "Amount",
      "address": "USDT address",
      "destAmount": "Estimated destination amount"
    },
    "submit": {
      "text": "Check data and proceed to payment"
    }
  },
  "ru": {
    "estimate_error": "Не удалось получить курс.",
    "submit": {
      "text": "Проверить и перейти к оплате"
    },
    "hints": {
      "email": "E-mail на который придет кассовый чек.",
      "pan": "Номер карты Visa, Mastercard, МИР.",
      "amount": "Сумма платежа от {min} до {max} {cur}.",
      "address": "USDT Trc20 адрес.",
      "calculating": "Вычисляем курс...",
      "calculating_error": "Не удалось получить курс."
    },
    "labels": {
      "pan": "Номер карты",
      "amount": "Сумма",
      "address": "USDT адрес",
      "destAmount": "Ожидаемая сумма получения"
    }
  }
}
</i18n>
